import { CurrencyFlag } from '@/shared/components'

import { Wallet } from '../../types'

type Props = {
  wallet: Wallet
}

export const AccountCurrencyCell = ({ wallet }: Props) => {
  return (
    <div className="flex">
      <CurrencyFlag currency={wallet.currency} />
    </div>
  )
}
